'use es6';

import { Map as ImmutableMap } from 'immutable';
import { RequestStatus } from '../constants/base';
import { REQUESTED_USER_ATTRIBUTES, RECEIVED_USER_ATTRIBUTES, REQUESTED_USER_ATTRIBUTES_FAILED, FINISH_FREE_LP_ONBOARDING_TOUR } from '../actions/ActionTypes';
import { SEEN_STATE_ATTRIBUTES, SHOULD_SHOW_FREE_LP_ONBOARDING_TOUR } from '../constants/tour';
const InitialState = new ImmutableMap({
  [SEEN_STATE_ATTRIBUTES]: ImmutableMap(),
  [SHOULD_SHOW_FREE_LP_ONBOARDING_TOUR]: false,
  status: RequestStatus.UNINITIALIZED
});
export default ((state = InitialState, action) => {
  switch (action.type) {
    case REQUESTED_USER_ATTRIBUTES:
      return state.set('status', RequestStatus.PENDING);

    case RECEIVED_USER_ATTRIBUTES:
      {
        const {
          parsedAttributes
        } = action.payload;
        return state.merge({
          [SEEN_STATE_ATTRIBUTES]: parsedAttributes[SEEN_STATE_ATTRIBUTES],
          [SHOULD_SHOW_FREE_LP_ONBOARDING_TOUR]: !!parsedAttributes[SHOULD_SHOW_FREE_LP_ONBOARDING_TOUR],
          status: RequestStatus.SUCCEEDED
        });
      }

    case REQUESTED_USER_ATTRIBUTES_FAILED:
      return state.set('status', RequestStatus.FAILED);

    case FINISH_FREE_LP_ONBOARDING_TOUR:
      return state.set(SHOULD_SHOW_FREE_LP_ONBOARDING_TOUR, false);

    default:
      return state;
  }
});